import { render, staticRenderFns } from "./MarketingMaterialsTab.vue?vue&type=template&id=59fd0925&scoped=true"
import script from "./MarketingMaterialsTab.vue?vue&type=script&lang=js"
export * from "./MarketingMaterialsTab.vue?vue&type=script&lang=js"
import style0 from "./MarketingMaterialsTab.vue?vue&type=style&index=0&id=59fd0925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd0925",
  null
  
)

export default component.exports